import styled from "styled-components";

export const FormSubtitle = styled.div`
  padding-bottom: 16px;
  font-size: 20px;
  border-bottom: 1px solid #B9B7CC;
  font-weight: bold;
  margin-bottom: 36px;
`;
